import React from "react";
import { Database, FileText, Grid } from "react-feather";
import { KgCatalogLayersIcon } from "../../kg/catalog/kgCatalogSectionIcons";
import type { KgSidebarSection } from "../../../services/kg/kgSectionRegistry";

const CanvasIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden
  >
    <path
      d="M8 2C9.10457 2 10 2.89543 10 4C10 5.10457 9.10457 6 8 6C6.89543 6 6 5.10457 6 4C6 2.89543 6.89543 2 8 2Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 10C5.10457 10 6 10.8954 6 12C6 13.1046 5.10457 14 4 14C2.89543 14 2 13.1046 2 12C2 10.8954 2.89543 10 4 10Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 10V9.33333C12 8.97971 11.8595 8.64057 11.6095 8.39052C11.3594 8.14048 11.0203 8 10.6667 8H5.33333C4.97971 8 4.64057 8.14048 4.39052 8.39052C4.14048 8.64057 4 8.97971 4 9.33333V10"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 8V6"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const OntologyIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
    <path d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12.6663 4.66667C13.4027 4.66667 13.9997 4.06971 13.9997 3.33333C13.9997 2.59695 13.4027 2 12.6663 2C11.93 2 11.333 2.59695 11.333 3.33333C11.333 4.06971 11.93 4.66667 12.6663 4.66667Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3.33333 14.0007C4.06971 14.0007 4.66667 13.4037 4.66667 12.6673C4.66667 11.9309 4.06971 11.334 3.33333 11.334C2.59695 11.334 2 11.9309 2 12.6673C2 13.4037 2.59695 14.0007 3.33333 14.0007Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6.93359 14.5996C8.21543 14.8102 9.53088 14.6418 10.7183 14.1149C11.9057 13.5881 12.9133 12.7258 13.6173 11.6341C14.3213 10.5424 14.691 9.26875 14.681 7.96976C14.671 6.67077 14.2817 5.40301 13.5609 4.32227" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.00021 1.40062C7.72361 1.20567 6.41787 1.3857 5.24165 1.91882C4.06543 2.45194 3.06937 3.31521 2.3745 4.40373C1.67963 5.49224 1.31587 6.75915 1.32742 8.05049C1.33896 9.34184 1.72532 10.602 2.43954 11.678" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const MetricIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
    <path d="M8 9.33268L10.6667 6.66602" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2.22634 12.6663C1.64115 11.6529 1.33305 10.5032 1.33301 9.33294C1.33296 8.16266 1.64098 7.013 2.22609 5.99949C2.8112 4.98599 3.65279 4.14437 4.66627 3.55922C5.67975 2.97407 6.8294 2.66602 7.99967 2.66602C9.16995 2.66602 10.3196 2.97407 11.3331 3.55922C12.3466 4.14437 13.1882 4.98599 13.7733 5.99949C14.3584 7.013 14.6664 8.16266 14.6663 9.33294C14.6663 10.5032 14.3582 11.6529 13.773 12.6663" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const BusinessRulesIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
    <path d="M10.6667 10.6673L12.6667 5.33398L14.6667 10.6673C14.0867 11.1007 13.3867 11.334 12.6667 11.334C11.9467 11.334 11.2467 11.1007 10.6667 10.6673Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1.33325 10.6673L3.33325 5.33398L5.33325 10.6673C4.75325 11.1007 4.05325 11.334 3.33325 11.334C2.61325 11.334 1.91325 11.1007 1.33325 10.6673Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.66675 14H11.3334" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 2V14" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2 4.66732H3.33333C4.66667 4.66732 6.66667 4.00065 8 3.33398C9.33333 4.00065 11.3333 4.66732 12.6667 4.66732H14" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const TribalKnowledgeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
    <path d="M10 9.33398C10.1333 8.66732 10.4667 8.20065 11 7.66732C11.6667 7.06732 12 6.20065 12 5.33398C12 4.27312 11.5786 3.2557 10.8284 2.50556C10.0783 1.75541 9.06087 1.33398 8 1.33398C6.93913 1.33398 5.92172 1.75541 5.17157 2.50556C4.42143 3.2557 4 4.27312 4 5.33398C4 6.00065 4.13333 6.80065 5 7.66732C5.46667 8.13398 5.86667 8.66732 6 9.33398" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 12H10" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6.66675 14.666H9.33341" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const PlatformHistoryIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
    <path d="M2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C5.84021 2 3.93721 3.08879 2.79128 4.74978" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2 2.66602V5.33268H4.66667" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 4.66602V8.33268L10.6667 9.66602" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const FeedbackIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
    <path d="M14 10C14 10.3536 13.8595 10.6928 13.6095 10.9428C13.3594 11.1929 13.0203 11.3333 12.6667 11.3333H4.66667L2 14V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H12.6667C13.0203 2 13.3594 2.14048 13.6095 2.39052C13.8595 2.64057 14 2.97971 14 3.33333V10Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const DataStoryIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
    <path d="M8 2L6.73333 5.86667C6.66847 6.06748 6.55688 6.25003 6.40772 6.3993C6.25856 6.54858 6.07609 6.66032 5.87533 6.72533L2 8L5.86667 9.26667C6.06748 9.33153 6.25003 9.44312 6.3993 9.59228C6.54858 9.74144 6.66032 9.92391 6.72533 10.1247L8 14L9.26667 10.1333C9.33153 9.93252 9.44312 9.74997 9.59228 9.6007C9.74144 9.45142 9.92391 9.33968 10.1247 9.27467L14 8L10.1333 6.73333C9.93252 6.66847 9.74997 6.55688 9.6007 6.40772C9.45142 6.25856 9.33968 6.07609 9.27467 5.87533L8 2Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const KG_SECTION_SIDEBAR_ICONS: Record<KgSidebarSection, React.ReactNode> = {
  canvas: <CanvasIcon />,
  dataSources: <Database size={16} />,
  tables: <Grid size={16} />,
  dataModel: <KgCatalogLayersIcon size={16} />,
  ontologies: <OntologyIcon />,
  metrics: <MetricIcon />,
  businessRules: <BusinessRulesIcon />,
  tribalKnowledge: <TribalKnowledgeIcon />,
  reports: <FileText size={16} />,
  dataStories: <DataStoryIcon />,
  platformHistory: <PlatformHistoryIcon />,
  feedback: <FeedbackIcon />,
  artifact: <FileText size={16} />,
};
